import { Stack, Typography } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import type { FC } from "react";

const NoOrderContent: FC = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={0.75}
      sx={{ py: 4, px: 2 }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <ShoppingCartOutlinedIcon sx={{ color: "action.active", fontSize: 20 }} />
        <Typography variant="body1" color="text.secondary">
          No Orders Yet
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        Start shopping to place your first order.
      </Typography>
    </Stack>
  );
};

export default NoOrderContent;